import moment from 'moment';
import { fromPairs, union } from 'ramda';
export var DayOfWeek = /*#__PURE__*/ function(DayOfWeek) {
    DayOfWeek["Monday"] = "Monday";
    DayOfWeek["Tuesday"] = "Tuesday";
    DayOfWeek["Wednesday"] = "Wednesday";
    DayOfWeek["Thursday"] = "Thursday";
    DayOfWeek["Friday"] = "Friday";
    DayOfWeek["Saturday"] = "Saturday";
    DayOfWeek["Sunday"] = "Sunday";
    return DayOfWeek;
}({});
const default_order = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
const _days = (start)=>union(default_order.filter((_, i)=>i >= default_order.indexOf(start)), default_order.filter((_, i)=>i < default_order.indexOf(start)));
const _ordered = fromPairs(default_order.map((x)=>[
        x,
        _days(x)
    ]));
export const days = (start = "Monday")=>_ordered[start];
export const date = (day, reference)=>(reference !== null && reference !== void 0 ? reference : moment()).day(default_order.indexOf(day));
export const getStartOfWeek = (dayOfWeek, currDay)=>{
    if (currDay.format('dddd') === "Sunday") {
        return currDay.subtract(6, 'days');
    }
    return date(dayOfWeek, currDay);
};
